export default "__VITE_ASSET__CeY7vw4T__"